import React from 'react';
import { motion } from 'framer-motion';
export function SalesHero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-cream-100" data-id="element-118">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-119">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-120">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-121">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block mb-4 px-3 py-1 rounded-full border border-cream-400 bg-cream-200 text-ink-700 text-sm font-medium tracking-wide" data-id="element-122">
              Para padres de atletas jóvenes (6-17 años)
            </motion.div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-ocean leading-tight mb-6" data-id="element-123">
              Tu hijo no tiene un problema de talento.{' '}
              <br className="hidden lg:block" data-id="element-124" />
              <span className="italic text-[#4A90C4]" data-id="element-125">
                Tiene un partido que nadie ve.
              </span>
            </h1>

            <p className="text-base sm:text-lg text-ink-500 mb-10 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed italic" data-id="element-126">
              La guía basada en neurociencia y psicología del deporte para
              padres que quieren construir atletas completos — y seres humanos
              extraordinarios.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-3" data-id="element-127">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full sm:w-auto px-8 py-4 bg-warm-orange hover:bg-[#d45e24] text-white font-semibold rounded-lg shadow-lg text-lg transition-colors duration-300 uppercase tracking-wide" onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-128">
                Quiero Entender
              </motion.button>
              <span className="text-sm text-ink-400" data-id="element-129">
                Acceso instantáneo · Formato Digital PDF
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-130">
            <div className="relative w-full max-w-md" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/m2bYLStdCKZAPaoiXVtqoC/1.jpg" alt="El Juego Invisible Book Cover" className="relative rounded-xl shadow-xl w-full object-cover border border-cream-300" data-id="element-132" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}